import { X, Mail, Loader2 } from "lucide-react";

export const SendHistoryModal = ({ historyModal, setHistoryModal, resend }) => {
  if (!historyModal.open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="send-history-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5 space-y-4">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-bold text-base">Send history</h3>
            <p className="text-xs muted mt-0.5">{historyModal.doc?.serial} · {historyModal.doc?.client_name}</p>
          </div>
          <button
            onClick={() => setHistoryModal({ open: false, doc: null, entries: null })}
            className="text-slate-400 hover:text-slate-600"
            data-testid="send-history-close"
          >
            <X size={16} />
          </button>
        </div>
        {historyModal.entries === null ? (
          <div className="flex items-center gap-2 text-sm muted py-4"><Loader2 size={14} className="animate-spin" /> Loading…</div>
        ) : historyModal.entries.length === 0 ? (
          <p className="text-sm muted py-4">This document has not been emailed yet.</p>
        ) : (
          <div className="divide-y divide-slate-100 max-h-72 overflow-y-auto">
            {historyModal.entries.map((e) => (
              <div key={e.id} className="py-2.5 text-sm flex items-start justify-between gap-2" data-testid={`send-history-entry-${e.id}`}>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <Mail size={13} className="text-[#0e6939] shrink-0" />
                    <span className="font-semibold break-all">{e.to}</span>
                    {(e.cc || []).length > 0 && <span className="text-xs muted">+{e.cc.length} cc</span>}
                  </div>
                  <div className="text-xs muted mt-0.5 pl-5">
                    by {e.sent_by_name} · {new Date(e.sent_at).toLocaleString()}
                  </div>
                </div>
                <button
                  data-testid={`resend-${e.id}`}
                  onClick={() => resend(e)}
                  disabled={historyModal.resending === e.id}
                  className="btn btn-ghost text-xs shrink-0"
                  title={`Resend to ${e.to}`}
                >
                  {historyModal.resending === e.id ? <Loader2 size={12} className="animate-spin" /> : "Resend"}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
